<template>
  <div class="popup-button display-middle" @click="buttonClick" :class="{ 'button-default' : buttonType === 'default', 'button-ok' : buttonType === 'ok' }">
    <span class="position-center fsdfds-button">
      <slot />
    </span>
  </div>
</template>

<script>
export default {
  props: {
    buttonType: {
      type: String,
      default: () => 'default'
    }
  },
  methods: {
    //  按钮点击效果控制
    buttonEffect(callback) {
      this.$root.timeout(() => callback(), 200)
    },
    //  点击按钮
    buttonClick() {
      this.buttonEffect(() => this.$emit('click'));
    }
  }
}
</script>

<style lang="stylus" scoped>
  .popup-button {
    position: relative;
    transition: all .2s;
    font-size: 17px;
    font-family: Helvetica Neue;
    font-weight: bold;
    text-transform: capitalize;
  }
  .popup-button:active {
    opacity: .3;
  }
  .button-default {
    color: #5D667F;
  }
  .button-ok {
    color: #F83E00;
  }
  .fsdfds-button {
    width: 100%;
    text-align center
  }
</style>